
export default class MapboxSource {
  constructor(type, source) {
    this.type = type;

    if (source.tiles !== undefined) {
      this.tiles = source.tiles;
    }

    if (source.tilesize !== undefined) {
      this.tileSize = source.tilesize;
    }

    if (source.data !== undefined) {
      this.data = source.data;
    }
    if (source.cluster !== undefined) {
      this.cluster = source.cluster;
    }
    if (source.clusterMaxZoom !== undefined) {
      this.clusterMaxZoom = source.clusterMaxZoom;
    }
    if (source.clusterRadius !== undefined) {
      this.clusterRadius = source.clusterRadius;
    }
    if (source.clusterProperties !== undefined) {
      this.clusterProperties = source.clusterProperties;
    }
  }
}
